type LogLevel = 'log' | 'warn' | 'error' | 'info';

interface LogEntry {
  timestamp: string;
  level: LogLevel;
  message: string;
}

const MAX_ENTRIES = 100;
const MAX_ENTRY_LENGTH = 500;

const buffer: LogEntry[] = [];
let initialized = false;

function safeStringify(args: unknown[]): string {
  return args
    .map((arg) => {
      if (typeof arg === 'string') return arg;
      try {
        return JSON.stringify(arg);
      } catch {
        return String(arg);
      }
    })
    .join(' ');
}

function pushEntry(level: LogLevel, args: unknown[]) {
  let message = safeStringify(args);
  if (message.length > MAX_ENTRY_LENGTH) {
    message = message.slice(0, MAX_ENTRY_LENGTH) + '...';
  }
  const entry: LogEntry = {
    timestamp: new Date().toISOString(),
    level,
    message,
  };
  if (buffer.length >= MAX_ENTRIES) {
    buffer.shift();
  }
  buffer.push(entry);
}

export function initConsoleCapture() {
  if (initialized) return;
  initialized = true;

  const levels: LogLevel[] = ['log', 'warn', 'error', 'info'];

  for (const level of levels) {
    const original = console[level].bind(console);
    console[level] = (...args: unknown[]) => {
      pushEntry(level, args);
      original(...args);
    };
  }
}

export function getConsoleLogsArray(): LogEntry[] {
  return [...buffer];
}

export function getConsoleLogs(): string {
  return buffer
    .map((e) => `[${e.timestamp}] [${e.level.toUpperCase()}] ${e.message}`)
    .join('\n');
}
